<div class="preliminary-layout">
  <header class="preliminary-header">
    <div class="preliminary-header__left" (click)="goToWebsite()">
      <img
        class="preliminary-header__logo preliminary-header__logo--emblem"
        src="assets/image/logo-gso-alt.svg"
        alt="GSO emblem" />

      <img
        class="preliminary-header__logo preliminary-header__logo--wordmark"
        src="assets/image/gso.svg"
        alt="Global Second Opinion" />
    </div>

    <div class="preliminary-header__right">

      <app-language-switcher></app-language-switcher>
    </div>
  </header>

  <main class="preliminary-main">
    <router-outlet></router-outlet>
  </main>
</div>
